import { useEffect, useState } from "react"
import axios from "axios"
import Cookies from 'js-cookie'


const AuthSystem = () => {
    const [user, setUser] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    const LoginaViaPassword = (inputEmail, inputPassword, history, setIsProcess) => {
        setIsLoading(true)
        const loginInfo = new URLSearchParams(Object.entries({
            username: inputEmail,
            password: inputPassword
        })).toString();
        /* http://116.203.191.150:8004 */
        axios.post('http://116.203.191.150:8004/users/login', loginInfo)
            .then(function (response) {
                if (response.data) {
                    setUser(response.data)
                    Cookies.set('access_token', response.data.access_token)
                    history.push('/')
                } else {
                    setIsLoading(false)
                }
            })
            .catch(function (error) {
                setUser(null)
                console.log(error);
            })
            .then(() => {
                setIsLoading(false)
                setIsProcess(false)
            })
    }

    const SignUpViaEmail = (firstName, lastName, email, phone, setIsProccess) => {
        const signUpInfo = new URLSearchParams(Object.entries({
            firstName,
            lastName,
            email,
            phone
        })).toString();
        /*   http://116.203.191.150:8004 */
        axios.post('http://116.203.191.150:8004/users/register', signUpInfo)
            .then(function (response) {
                console.log(response)
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(() => {
            })
    }


    const handleSignOut = (history) => {
        Cookies.remove('access_token')
        setUser(null)
        history.push('/')
    }


    useEffect(() => {
        setIsLoading(true)
        const access_token = Cookies.get("access_token")
        if (access_token) {
            /* http://116.203.191.150:8004 */
            axios.get(`http://116.203.191.150:8004/users/current_user/${access_token}`)
                .then(function (response) {
                    if (response.data) {
                        setUser(response.data)
                    } else {
                        setUser(null)
                    }
                })
                .catch(function (error) {
                    setUser(null)
                    console.log(error);
                })
                .then(function () {
                    setIsLoading(false)
                });
        } else {
            setIsLoading(false)
        }
    }, [])

    return {
        user,
        LoginaViaPassword,
        isLoading,
        handleSignOut,
        SignUpViaEmail
    }
}

export default AuthSystem;